import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ErrorStateMatcher,
  JbActivityHeaderModule,
  JbButtonModule,
  JbDatePickerModule,
  JbErrorModule,
  JbFormFieldContainerModule,
  JbSrOnlyModule,
  ShowOnSubmitErrorStateMatcher,
} from 'jb-component-library';

import { PipesModule } from '../../../../shared/ui/pipes/pipes.module';
import { DateRangePickerComponent } from './date-range-picker.component';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  JbDatePickerModule,
  JbErrorModule,
  JbSrOnlyModule,
  JbFormFieldContainerModule,
  PipesModule,
  JbActivityHeaderModule,
  JbButtonModule,
];

const DECLARATIONS = [DateRangePickerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnSubmitErrorStateMatcher },
  ],
  exports: [...MODULES, ...DECLARATIONS],
})
export class DateRangePickerModule {}
